module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='\n<!-- src/app/employer/templates/settings/integrations/quickbooks/PayrollItem.ejs -->\n<td class="td-nowrap">\n    '+
((__t=( model.get('name') ))==null?'':_.escape(__t))+
'\n</td>\n<td>\n    ';
 if (employerIntegration) { 
__p+='\n        <select name="remoteId"\n            class="form-control js-ext js-ext-employer">\n            <option></option>\n            ';
 qbAccounts.forEach(function (account) { 
__p+='\n                <option value="'+
((__t=( account.Id ))==null?'':_.escape(__t))+
'"\n                    '+
((__t=( employerIntegration.get('remoteId') === account.Id ? 'selected' : '' ))==null?'':_.escape(__t))+
'>\n                    '+
((__t=( account.FullyQualifiedName ))==null?'':_.escape(__t))+
'\n                </option>\n            ';
 }) 
__p+='\n        </select>\n    ';
 } 
__p+='\n</td>\n<td>\n    ';
 if (employeeIntegration) { 
__p+='\n    <select name="remoteId"\n        class="form-control js-ext js-ext-employee">\n        <option></option>\n        ';
 qbAccounts.forEach(function (account) { 
__p+='\n            <option value="'+
((__t=( account.Id ))==null?'':_.escape(__t))+
'"\n                '+
((__t=( employeeIntegration.get('remoteId') === account.Id ? 'selected': '' ))==null?'':_.escape(__t))+
'>\n                '+
((__t=( account.FullyQualifiedName ))==null?'':_.escape(__t))+
'\n            </option>\n        ';
 }) 
__p+='\n    </select>\n    ';
 } 
__p+='\n</td>\n';
}
return __p;
};



//////////////////
// WEBPACK FOOTER
// ./app/employer/templates/settings/integrations/quickbooks/PayrollItem.ejs
// module id = 883
// module chunks = 1